import { initOperations } from '../../../../../profint.shared10/src/Profint.Shared.UI/assets/operation-controls';

initOperations({
  skipLink: link => Boolean(document.getElementById('patient-search-dialog') && link.origin === window.location.origin
    && ['/pacientes', '/pacientes/buscar'].includes(link.pathname)),
});
